/**
 * Admin BFF
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { SortExpression } from './sort-expression';
import { DateTimePeriod } from './date-time-period';


export interface ExportUserTransactionsRequest { 
    skip?: number;
    take?: number;
    includeTotalCount?: boolean | null;
    sortExpressions?: Array<SortExpression> | null;
    userId: string;
    typeIds?: Array<number> | null;
    datePeriod?: DateTimePeriod;
    includeTemporaryTransactions?: boolean;
}

